import { useSelector } from "react-redux";
import { RootState } from "../data/redux/store";
import { PermissionObject } from "../../core/data/redux/authSlice";

type PermissionType =
  | "read"
  | "write"
  | "create"
  | "delete"
  | "export"
  | "allow_all";

export const usePermission = (
  moduleName: string,
  permission: PermissionType
): boolean => {
  const { permissions, role, employeeId } = useSelector(
    (state: RootState) => state.auth
  );

  // If no permissions are found, deny access
  if (!permissions) {
    console.warn("No permissions found in state.");
    return false;
  }

  // Find the matching module key in a case-insensitive manner
  const moduleKey = Object.keys(permissions).find(
    (key) => key.toLowerCase() === moduleName.toLowerCase()
  );

  // If no matching module is found, deny access
  if (!moduleKey) {
    console.warn(`No permissions found for module: ${moduleName}`);
    return false;
  }

  const modulePermissions = permissions[moduleKey];

  // If module permissions don't exist, deny access
  if (!modulePermissions) {
    console.warn(`No permissions found for module: ${moduleName}`);
    return false;
  }

  // If allow_all is true, grant access to all permissions
  if (modulePermissions.allow_all) {
    return true;
  }

  // Otherwise, check for the specific permission
  return Boolean(modulePermissions[permission]);
};